import styled from "styled-components";
import { colors } from "colors";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const InputElement = styled.input`
  padding: 10px;
  border: 1px solid ${colors.silver};
  border-radius: 4px;
  outline: none;
  font-size: 14px;
  
  ::placeholder {
    color: ${colors.silver};
  }

  &[disabled] {
    background-color: ${colors.alabaster};
    cursor: not-allowed;
  }
  
  &[data-error="true"] {
    border: 1px solid ${colors.strawberry};
  }
`;

export const Label = styled.label`
  font-size: 14px;
  color: ${colors.slateGrey};
 
  &[required] {
    ::after {
      content: " *";
      color: ${colors.strawberry};
    }
  }
`;
